import styled from "styled-components";
import { Layout } from "antd";

const { Content } = Layout;

export const StyledMainContentView = styled(Content)<{ minusHeight: number }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0;
  min-height: auto !important;
  margin: 0px !important;
  height: ${({ minusHeight }) => `calc(100vh - ${minusHeight}px)`} !important;
  overflow-x: hidden;
  overflow-y: auto;
`;
